<template>
  <v-card class="mx-auto">
    <v-card-text>
      <div class="overline">{{codiceCaso}}</div>
      <v-container>
        <v-row v-if="newMessagesOpen.length>0">
          <v-col cols="12" md="6" v-for="message in newMessages" :key="message.id">
            <v-alert
              class="my-0"
              dense
              dismissible
              v-model="message.open"
              :icon="message.icon"
              :type="message.type"
            >{{message.msg}}</v-alert>
          </v-col>
        </v-row>
      </v-container>
      <v-toolbar>
        <UserSymptomsDialog
          @editing-state-change="e => $emit('editing-state-change', e)"
          @on-done="OnAddSymptoms"
        >Aggiungi Parametri</UserSymptomsDialog>
      </v-toolbar>
    </v-card-text>
    <v-list :key="unsyncKey">
      <v-list-item v-for="dp in reverseTS" :key="dp.key || dp.ts">
        <UserSymptoms
          :symptoms="dp.symptoms"
          read-only
          :db-key="dp.key"
          :card-title="dateOfReading(dp.ts) + ' ' + timeOfReading(dp.ts)"
          :time-stamp="dp.ts"
          @edit-user-symptoms="OnEditUserSymptoms"
        />
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import UserSymptomsDialog from "@/components/UserSymptomsDialog";
import UserSymptoms from "@/components/UserSymptoms";
// https://michaelnthiessen.com/force-re-render/
export default {
  components: {
    UserSymptomsDialog,
    UserSymptoms
  },
  methods: {
    OnEditUserSymptoms(e) {
      // console.log(e);
    },
    OnAddSymptoms(e) {
      this.$store.dispatch("addUserTimeSeries", {
        user: this.user,
        symptoms: e
      });
      this.$gtag.event("addUserTimeSeries", {
        event_category: "engagement",
        event_label: "addData",
        value: 50
      });
    },
    timeOfReading(ts) {
      // https://stackoverflow.com/questions/2388115/get-locale-short-date-format-using-javascript
      const time = new Date(ts);
      return time.toLocaleTimeString();
    },
    dateOfReading(ts) {
      // https://stackoverflow.com/questions/2388115/get-locale-short-date-format-using-javascript
      const time = new Date(ts);
      return time.toLocaleDateString();
    },
    reverse(items) {
      return items.slice().reverse();
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  // see https://github.com/Code-Pop/watch-us-build-trello/blob/master/src/views/Task.vue
  computed: {
    ...mapGetters(["getUserTimeSeries", "getUnsyncedTimeSeriesTS"]),
    userTimeSeries() {
      return this.getUserTimeSeries(this.user.id);
    },
    unsyncKey() {
      return this.getUnsyncedTimeSeriesTS.join("-");
    },
    reverseTS() {
      return this.userTimeSeries.slice().reverse();
    },
    newMessages() {
      let msgType = "nouser";
      if (this.reverseTS && this.reverseTS.length > 0) {
        msgType = "periodic";
      }
      return this.messages.filter(m => m.msgType === msgType);
    },
    newMessagesOpen() {
      return this.newMessages.filter(m => m.open);
    },
    codiceCaso() {
      if (this.user.key) {
        return "codice caso: xxx-xxx-" + this.user.key.slice(-4);
      } else {
        return "codice caso: xxx-xxx-xxxx";
      }
    }
  },
  data: () => ({
    dialog: false,
    messages: [
      {
        id: 0,
        msgType: "periodic",
        msg: "Aggiorna periodicamente la situazione.",
        icon: "mdi-clock-alert-outline",
        type: "info",
        open: true
      },
      {
        id: 1,
        msgType: "periodic",
        msg: "Puoi Aggiungere altri ammalati",
        icon: "mdi-account-multiple-plus",
        type: "info",
        open: true
      },

      {
        id: "_first",
        msgType: "nouser",
        msg: "Aggiungere sintomi attuali",
        icon: "mdi-clipboard-plus-outline",
        type: "success",
        open: true
      }
    ]
  }),
  mounted() {
    this.$gtag.event("UserCardView", {
      event_category: "engagement",
      event_label: "view",
      value: 1
    });
  }
};
</script>
